import { useDispatch } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
import { useCallback } from "react";
import { blockUser } from "../../store/reducers/media.reducer";

export const useBlockUser = () => {
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();

    const handleBlockUser = useCallback((userId, blockVideos) => {
        if (keycloak.token && userId) {
            dispatch(blockUser({ userId, blockVideos, token: keycloak.token }));
        } else {
            console.error("Cannot block user: not authenticated or no user ID provided.");
        }
    }, [dispatch, keycloak.token]);

    return { handleBlockUser };
};